import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { appendAccountToUrl, getAccountFromUrl } from '../../utils/appointments/urlUtils';

const AuthGuard = ({ children }) => {
  const location = useLocation();
  const isAuth = !!localStorage.getItem('token'); // Always get the latest value

  // If not authenticated, redirect to login
  if (!isAuth) {
    // Get the current account from URL to maintain context
    const currentAccount = getAccountFromUrl(location.search);
    return <Navigate to={appendAccountToUrl("/login")} state={{ from: location }} replace />;
  }

  return <>{children}</>; // Render protected content
};

export default AuthGuard;
